exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * Any styles specific to the Product module should live here.  Import as needed.\n */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/admin/adminModuleStyles.css
// module id = 1343
// module chunks = 1